import { useMemo } from 'react'
import { getUserWeekStartsOn } from '~/helpers/dateHelper'

import { Timespan } from '@hap/utils'

import { useCurrentUserSetting } from './useCurrentUserSetting'

/**
 * React hook to get the user's preferred first day of the week.
 * First checks user preference ('auto', 0, or 1).
 * If 'auto' or not set, uses Intl.Locale.getWeekInfo() with Monday as fallback.
 *
 * @returns 0-6 (0=Sunday, 1=Monday, etc.) matching date-fns convention
 */
export function useWeekStartsOn(): Timespan.DayOfWeek {
  const [userPreference] = useCurrentUserSetting('session', 'weekStartsOn', 'auto')
  return useMemo(() => {
    // If user has explicitly set Sunday (0) or Monday (1), use that
    if (userPreference === '0') {
      return 0
    } else if (userPreference === '1') {
      return 1
    }

    // Otherwise, fall back to OS detection
    return getUserWeekStartsOn()
  }, [userPreference])
}
